<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRenderStatusComposable } from '../useRenderStatusComposable';

interface Props {
  ruleData: object;
}
defineProps<Props>();

const { t } = useI18n({ useScope: 'global' });
const { renderClass, renderStatus } = useRenderStatusComposable();
</script>
<template>
  <div class="hotel-rule mt-4">
    <div v-if="ruleData.noteRuleHotel" class="mt-2 mb-3 ml-4 font-bold text-lg text-900">{{ ruleData.noteRuleHotel }}</div>
    <div class="mt-2 ml-4">
      <ul>
        <li v-if="ruleData.ruleHotelDisplay.hotelRule !== undefined" class="text-lg mt-1 hotel_rule">
          {{ t('rule.hotel_rule.hotel_rule') }} <span :class="renderClass(ruleData.ruleHotelDisplay.hotelRule)">({{ renderStatus(ruleData.ruleHotelDisplay.hotelRule) }})</span>
        </li>
        <li v-if="ruleData.ruleHotelDisplay.maxNumbersOfRooms !== undefined" class="text-lg mt-1">
          {{ t('rule.hotel_rule.max_number_of_room') }} <span :class="renderClass(ruleData.ruleHotelDisplay.maxNumbersOfRooms)">({{ renderStatus(ruleData.ruleHotelDisplay.maxNumbersOfRooms) }})</span>
        </li>
        <li v-if="ruleData.ruleHotelDisplay.exRoomCategory !== undefined" class="text-lg mt-1">
          {{ t('rule.hotel_rule.ex_room_category') }} <span :class="renderClass(ruleData.ruleHotelDisplay.exRoomCategory)">({{ renderStatus(ruleData.ruleHotelDisplay.exRoomCategory) }})</span>
        </li>
        <li v-if="ruleData.ruleHotelDisplay.preferred !== undefined" class="text-lg mt-1">
          {{ t('rule.hotel_rule.preferred') }} <span :class="renderClass(ruleData.ruleHotelDisplay.preferred)">({{ renderStatus(ruleData.ruleHotelDisplay.preferred) }})</span>
        </li>
        <li v-if="ruleData.ruleHotelDisplay.roomPricing !== undefined" class="text-lg mt-1">
          {{ t('rule.hotel_rule.roomPricing') }} <span :class="renderClass(ruleData.ruleHotelDisplay.roomPricing)">({{ renderStatus(ruleData.ruleHotelDisplay.roomPricing) }})</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.box-border {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: center;
}
</style>
